import pluralize from 'pluralize'
import * as React from 'react'

import { TypeStyle } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

import {
  ReviewCountCopy,
  ReviewCountTextContainer,
  ReviewStarIconContainer,
  ReviewStars,
  ReviewStarsContainer,
} from './styles'

import type { ProductReviewSet } from '../../../../../../types/graphql'

type SimpleReviewsSectionProps = {
  productReviews: ProductReviewSet | undefined
}

export const SimpleReviewsSection: React.FC<SimpleReviewsSectionProps> = ({
  productReviews,
}: SimpleReviewsSectionProps) => {
  const {
    detailsSection: { reviewsCountNoun, reviewsTooltipPrefix, reviewsTooltipSuffix },
  } = useTranslation()

  const reviewTitleText: string = productReviews?.totalReviews
    ? `${productReviews?.totalReviews} ${pluralize(reviewsCountNoun, productReviews?.totalReviews)}`
    : ''

  const displayRating = (productReviews?.averageScore || 0).toFixed(2)

  const tooltip = `${reviewsTooltipPrefix} ${displayRating} ${reviewsTooltipSuffix}`

  return (
    <ReviewStarsContainer data-testid='product-reviews'>
      <ReviewStarIconContainer>
        <ReviewStars
          isLarge
          rating={productReviews?.averageScore || 0}
          aria-label={tooltip}
          title={tooltip}
        />
      </ReviewStarIconContainer>
      <ReviewCountTextContainer>
        <ReviewCountCopy>
          <TypeStyle.HeadlineMicro>
            (
            <span>
              <u>{reviewTitleText}</u>
            </span>
            )
          </TypeStyle.HeadlineMicro>
        </ReviewCountCopy>
      </ReviewCountTextContainer>
    </ReviewStarsContainer>
  )
}

export default SimpleReviewsSection
